import { BCMSDefaultModel, BCMSRecord, StateManager, useBCMSContext, useParams, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from 'components/ui/UIButton';
import Classes, { Transaction } from 'model';
import React from 'react';
import DisputeTransactionDetailsWidget from '../widgets/DisputeTransactionDetailsWidget';
import "./styles.css";

/**
 * @function ReviewingDisputeView
 * @return {React.Component}
 * @exported true
 * @description The view that reviews the dispute information
 */

export default function ReviewingDisputeView(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const navigate = useRoute();
  const params = useParams();
  const paramsTransactionID = useParams().transactionID ?? "0";
  const hasData = props.data === undefined ? false : true;
  let hasDataTransaction = false;

  if(hasData) {
    hasDataTransaction = props.data.transaction === undefined ? false : true;
  }
  let transactionID =  hasDataTransaction ? props.data.transaction.id : paramsTransactionID;

  const data = { ...getDefaultData(transactionID), ...props.data ?? {} };

  const ui = { ...getDefaultUI(), ...props.ui ?? {} };
  const { goStep, nextStep, prevStep } = useWorkflow() ?? {};

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    done: () => navigate(-1)
  });

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = transactionID => {
  let transaction = Transaction.initAll().filter((_transaction) => {
    return _transaction.id === transactionID;
  })[0];
  
  // This page will pass transaction id "0" above.
  // But if debit is off and card is on, 
  // then transaction id "0" does not exist,
  // so handle that condition in this ternary here.
  transaction = transaction ? transaction : Transaction.initAll()[0];
  let dispute = BCMSDefaultModel.transactionDispute();
  dispute.transaction = transaction;

  if(transaction.transactionDispute) {
    dispute = transaction.transactionDispute;
  }

  return {
    dispute
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, done } = useStateManager();
  const dispute = data.dispute ?? {};
  const headerDataPoint = { "data-point" : "Reviewing_Dispute_Label" };

  return (
    <div className="reviewing-dispute-view">
      <div className="flex-container flex-vertical align-center-container">
        <h2 { ...headerDataPoint }>Reviewing Dispute</h2>
        <p className="review-dispute-text">We are currently reviewing your dispute.</p>

        {/* Details Widget */}
        <DisputeTransactionDetailsWidget dispute={ dispute } />

        <p>If you have any questions regarding this disputed transaction, call us.</p>

        <UIPrimaryButton text="Done" onClick={ done } />
      </div>
    </div>
  );
}